import axios from "../api/axios";
import useAuth from "./useAuth";
import useCookies from "react-cookie/cjs/useCookies";

const useRefreshToken = () => {
  const { cookies } = useAuth();
  const [, setCookies] = useCookies(["auth"]);

  const refresh = async () => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      throw new Error("No refresh token available");
    }

    try {
      const response = await axios.post("/auth-serviceV3/auth/refresh-token", {
        refreshToken: refreshToken
      });

      const res = response.data;
      if (res.success && res.data) {
        const newAccessToken = res.data.accessToken;
        const newRefreshToken = res.data.refreshToken;

        // Store new tokens in localStorage
        localStorage.setItem("token", newAccessToken);
        if (newRefreshToken) {
          localStorage.setItem("refreshToken", newRefreshToken);
        }

        // Keep local userDetails synced
        const userDetailsStr = localStorage.getItem("userDetails");
        if (userDetailsStr) {
          const userDetails = JSON.parse(userDetailsStr);
          userDetails.token = newAccessToken;
          localStorage.setItem("userDetails", JSON.stringify(userDetails));
        }

        // Update the auth cookie so all pages and RequireAuth get the fresh token
        const currentAuth = cookies?.auth;
        if (currentAuth) {
          const updatedAuth = {
            ...currentAuth,
            token: newAccessToken
          };
          const expirationTime = new Date().getTime() + 900000; // 15 mins
          setCookies("auth", JSON.stringify(updatedAuth), { expires: new Date(expirationTime), path: "/" });
        }

        return newAccessToken;
      } else {
        throw new Error(res.message || "Failed to refresh token");
      }
    } catch (error) {
      console.error("Token refresh failed in hook:", error);
      throw error;
    }
  };

  return refresh;
};

export default useRefreshToken;
